import Vue from 'vue'
import Vuex from 'vuex'
import syncLocalStorage from './plugins/sync-local-storage'
import app from './modules/app'
import user from './modules/user'
import pracTrain from './modules/pracTrain'
import practice from './modules/practice'

// default router permission control
import permission from './modules/permission'

// dynamic router permission control (Experimental)
// import permission from './modules/async-router'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    pracTrain,
    practice
  },
  state: {},
  mutations: {},
  actions: {},
  getters,
  plugins: [
    syncLocalStorage,
  ],
  // strict: process.env.NODE_ENV === 'development',
})
